'use client';

import { forwardRef, useEffect, useState } from 'react';
import type { SwiperClass, SwiperRef } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper/types';

import { Swiper } from '@/components/ui/swiper';
import { cn } from '@/utils';

import type { SwiperProps } from './swiper.interface';

interface SwiperKeyboardAccesibilityProps extends SwiperProps {
  defaultActiveIndex?: number;
}

export const SwiperKeyboardAccesibility = forwardRef<SwiperRef, SwiperKeyboardAccesibilityProps>(({ defaultActiveIndex, onSwiper, className, ...props }, ref) => {
  const [swiper, setSwiper] = useState<SwiperType>();
  const handleSwiper = (swiper: SwiperClass) => {
    if (defaultActiveIndex !== undefined && defaultActiveIndex > 0) {
      swiper.slideTo(defaultActiveIndex, 0);
    }
    setSwiper(swiper);
    onSwiper?.(swiper);
  };

  useEffect(() => {
    if (!swiper) {
      return;
    }

    const handleKeyPress = ({ key }: KeyboardEvent) => {
      switch (key) {
        case 'ArrowRight':
          swiper.slideNext();
          break;
        case 'ArrowLeft':
          swiper.slidePrev();
          break;
        default:
          break;
      }
    };
    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [swiper]);

  return (
    <Swiper ref={ref} onSwiper={handleSwiper} className={cn(!swiper && 'invisible', className)} {...props} />
  );
});
